<template>
	<section class="live-wrap">
		<ul class="live-item-wrap">
			<li
				v-for="live of $store.state.apiTypeMap[5].api"
				:class="`live-item ${liveSelected === live.game ? 'active' : ''}`"
				:key="live.game"
			>
				<div class="container">
					<img class="banner" :src="require(`../../static/img/sport/${live.img}.png`)" alt="banner" />
					<div class="content-wrap">
						<div class="api-logo">
							<img :src="require(`../../static/img/sport/logo_${live.api}.png`)" :alt="live.api" />
						</div>
						<div class="api-summary">
							<p class="title">亚洲最佳, 线上体育</p>
							<p class="sub-title">超高赔率, 巨额奖金送不停</p>
						</div>
						<a class="live-btn" @click="toGame(live)">立即游戏<img src="@/static/img/arrow.png" alt="arrow" /></a>
					</div>
				</div>
			</li>
		</ul>
		<div class="live-nav-wrap">
			<div class="container">
				<ul class="live-nav">
					<li
						v-for="live of $store.state.apiTypeMap[5].api"
						:class="`live-nav-item ${liveSelected === live.game ? 'active' : ''}`"
						:key="live.game"
					>
						<a href="javascript:" @mouseover="liveSelected = live.game">
							<div class="default">
								<img :src="require(`@/static/img/sport/${live.api}-default.png`)" alt="name" />
								<p>{{ live.name }}</p>
							</div>
							<div class="active">
								<img :src="require(`@/static/img/sport/${live.api}-active.png`)" alt="name" />
								<p>{{ live.name }}</p>
							</div>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</section>
</template>

<script>
import { game } from "../../mixins/game";

export default {
	mixins: [game], // toGame
	data() {
		return {
			liveSelected: 17, // 当前选中的API;值是game
		};
	},
};
</script>

<style lang="scss">
.container {
	position: relative;
	margin: auto;
	.banner {
		display: block;
		margin: -25px auto 0;
		max-width: 100%;
	}
}
.live-wrap {
	position: relative;
	width: 100%;
	height: 784px;
	background-image: url(~@/static/img/bg.jpg);
	/*大背景*/
	.live-item-wrap {
		.live-item {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 784px;
			transition: 0.5s;
			z-index: 0;
			opacity: 0;

			&.active {
				opacity: 1;
				z-index: 10;
			}

			.content-wrap {
				width: 900px;
				height: 150px;
				position: absolute;
				top: 600px;
				left: 50%;
				transform: translateX(-50%);
				text-align: center;
				padding-left: 36px;
				padding-right: 14px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				background-image: url(~@/static/img/game-start-bg.png);
				color: #fff;
				.api-logo {
					img {
						width: 238px;
						max-width: 100%;
					}
				}
				.api-summary {
					font-size: 21px;
					font-family: PingFangSC;
					font-weight: normal;
					flex: 1;
					.title {
						font-size: 30px;
					}
					.subTitle {
						font-size: 18px;
					}
				}

				.live-btn {
					display: block;
					width: 222px;
					height: 62px;
					background-image: url(~@/static/img/game-start-btn.png);
					background-size: cover;
					background-repeat: no-repeat;
					background-position: 0 5px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 27px;
					font-family: PingFangSC;
					&:hover {
						animation: gelatin 0.5s 1;
					}
					img {
						width: 14px;
						margin-left: 10px;
					}
				}
			}
		}
	}

	/*API切换导航*/
	.live-nav-wrap {
		position: absolute;
		top: auto;
		left: 0;
		right: 0;
		z-index: 20;
		width: 100%;
		bottom: 217px;

		.live-nav {
			display: flex;
			justify-content: center;

			li {
				padding: 0 10px;
				&:hover .active {
					animation: gelatin 0.5s 1;
				}
				.active {
					display: none;
				}
				&.active {
					.default {
						display: none;
					}
					.active {
						display: block;
						width: 121px;
						height: 121px;
						border-radius: 100%;
						text-align: center;
						overflow: hidden;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: flex-end;
						padding-bottom: 18px;
						background-image: url(~@/static/img/video/active-bg.png);
						img {
							position: relative;
							width: 53px;
							max-width: 100%;
							z-index: 2;
						}
						p {
							position: relative;
							font-size: 17.5px;
							margin-top: 12px;
							color: #fff;
							z-index: 2;
						}
					}
				}
				.default {
					position: relative;
					width: 121px;
					height: 121px;
					border-radius: 100%;
					text-align: center;
					overflow: hidden;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: flex-end;
					padding-bottom: 18px;
					&::after {
						content: "";
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						background-color: #888;
						opacity: 0.8;
					}
					img {
						position: relative;
						max-width: 100%;
						z-index: 2;
					}
					p {
						position: relative;
						font-size: 17.5px;
						margin-top: 12px;
						color: #fff;
						z-index: 2;
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/sport/sport.vue